import React from 'react'

export default props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 12 16"
  >
    <g id="OPP---CA1-&amp;-CA2" fill="none" fillRule="evenodd">
      <g id="OPPD-26.1" transform="translate(-30 -89)">
        <g id="Clients-Copy" transform="translate(0 70)">
          <g id="Group-2" transform="translate(30 19)">
            <g id="Search">
              <path
                d="M5.5,11 C8.53756612,11 11,8.53756612 11,5.5 C11,2.46243388 8.53756612,0 5.5,0 C2.46243388,0 0,2.46243388 0,5.5 C0,8.53756612 2.46243388,11 5.5,11 Z M1.00000444,5.48735964 C1.00698095,3.00373573 3.02478133,0.995360314 5.50841439,1.00000805 C7.99204746,1.00465579 10.002317,3.02056911 9.999998,5.50420174 C9.99767902,7.98783436 7.98364849,9.9999902 5.50001108,10 C4.30485852,9.99832495 3.15932185,9.5219461 2.31540665,8.67566161 C1.47149144,7.82937713 0.998327038,6.6825104 1.00000444,5.48735964 Z"
                id="Shape"
                fill="#C9CDD4"
                fillRule="nonzero"
              />
              <path
                d="M8,10 C8.1519429,10.2657621 8.26466403,10.4629217 8.33816338,10.5914789 C9.51224196,12.6450503 10.405964,14.2082523 11.0193295,15.281085"
                id="Path-2"
                stroke="#C9CDD4"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/globalSearch.js